import {AvatarMenuItem} from '@coolcolduk/ui-mui';
import {signOut} from 'firebase/auth';
import {Logout} from '@mui/icons-material';
import {NavigateFunction} from 'react-router';
import {UserAccount} from '../__generated__/resolvers-types';
import {getSettings} from '../pages/settings';
import {firebaseAuth} from '../setup/firebase';

export const createAvatarMenu = (user: UserAccount | null, navigate: NavigateFunction): AvatarMenuItem[] => [
  ...getSettings(user).map((setting) => ({
    label: setting.title,
    onClick: () => navigate(setting.path),
    icon: <setting.IconComponent />,
  })),
  {
    label: 'Logout',
    onClick: () => signOut(firebaseAuth),
    icon: <Logout />,
  },
];
